import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Select, message, Space } from 'antd';
import { useParams } from 'react-router-dom';
import useCompanyNavigate from '../../utils/useCompanyNavigate';
import { storeAdminApi, storeApi } from '../../services/api';

const StoreAccountForm = () => {
  const navigate = useCompanyNavigate();
  const { id } = useParams();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(!!id);
  const [stores, setStores] = useState([]);

  useEffect(() => {
    fetchStores();
    if (id) {
      fetchData();
    }
  }, [id]);

  const fetchStores = async () => {
    try {
      const res = await storeApi.list({ status: 1, limit: 100 });
      if (res.success) {
        setStores(res.data.list);
      }
    } catch (error) {
      console.error('获取门店列表失败', error);
    }
  };

  const fetchData = async () => {
    setInitialLoading(true);
    try {
      const res = await storeAdminApi.detail(id);
      if (res.success) {
        form.setFieldsValue(res.data);
      }
    } catch (error) {
      message.error('获取账户信息失败');
      navigate('/admin/store-accounts');
    } finally {
      setInitialLoading(false);
    }
  };

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      if (id) {
        await storeAdminApi.update(id, values);
        message.success('更新成功');
      } else {
        await storeAdminApi.create(values);
        message.success('创建成功');
      }
      navigate('/admin/store-accounts');
    } catch (error) {
      message.error(id ? '更新失败' : '创建失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2>{id ? '编辑账户' : '新增账户'}</h2>
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={{ is_active: 1 }}
        style={{ maxWidth: 600 }}
      >
        <Form.Item
          name="store_id"
          label="所属门店"
          rules={[{ required: true, message: '请选择门店' }]}
        >
          <Select placeholder="请选择门店">
            {stores.map(store => (
              <Select.Option key={store.id} value={store.id}>
                {store.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="username"
          label="用户名"
          rules={[
            { required: true, message: '请输入用户名' },
            { min: 3, max: 50, message: '用户名长度为3-50个字符' }
          ]}
        >
          <Input placeholder="请输入用户名" />
        </Form.Item>

        <Form.Item
          name="password"
          label="密码"
          rules={[
            { required: !id, message: '请输入密码' },
            { min: 6, message: '密码至少6位' }
          ]}
        >
          <Input.Password placeholder={id ? '留空则不修改密码' : '请输入密码'} />
        </Form.Item>

        <Form.Item name="real_name" label="真实姓名">
          <Input placeholder="请输入真实姓名" />
        </Form.Item>

        <Form.Item name="phone" label="手机号">
          <Input placeholder="请输入手机号" />
        </Form.Item>

        <Form.Item name="is_active" label="状态">
          <Select>
            <Select.Option value={1}>启用</Select.Option>
            <Select.Option value={0}>禁用</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item>
          <Space>
            <Button type="primary" htmlType="submit" loading={loading}>
              {id ? '更新' : '创建'}
            </Button>
            <Button onClick={() => navigate('/admin/store-accounts')}>
              取消
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </div>
  );
};

export default StoreAccountForm;
